import { MessageCircle, GraduationCap, Trophy } from "lucide-react";
import { WHATSAPP_LINK } from "@/data/content";

export default function MobileCTA({ scrollTo }) {
  return (
    <div
      data-testid="mobile-cta"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-brand-line bg-white/95 backdrop-blur-xl md:hidden"
    >
      <div className="grid grid-cols-3">
        <button
          data-testid="mobile-cta-enquire"
          onClick={() => scrollTo("#enquire")}
          className="bg-brand-green py-3.5 text-[13px] font-bold text-white"
        >
          Enquire Now
        </button>
        <a
          data-testid="mobile-cta-scholarship"
          href="/scholarship-exam"
          className="relative flex items-center justify-center gap-1.5 bg-brand-terra py-3.5 text-[13px] font-bold text-white"
        >
          <Trophy className="h-4 w-4" />
          Scholarship
          <span data-testid="mobile-cta-scholarship-free-badge" className="absolute right-1 top-1 rounded-full bg-white px-1.5 py-0.5 text-[8px] font-black leading-none tracking-wider text-brand-terra shadow-sm">FREE</span>
        </a>
        <a
          data-testid="mobile-cta-admission"
          href="/admission-form"
          className="flex items-center justify-center gap-1.5 bg-brand-ink py-3.5 text-[13px] font-bold text-white"
        >
          <GraduationCap className="h-4 w-4" />
          Admission
        </a>
      </div>
      <a
        data-testid="mobile-cta-whatsapp"
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center gap-2 bg-[#25D366] py-3 text-sm font-bold text-white"
      >
        <MessageCircle className="h-4 w-4" />
        Chat on WhatsApp
      </a>
    </div>
  );
}
